import { fieldErrorId } from '../fieldIds';

// A field draws no error line and holds no room for one: it marks itself, the
// card's status line names the problem, and this carries the full message to the
// control's accessible description
export const FieldError = ({
  id,
  error,
}: {
  id: string;
  error: string | undefined;
}) =>
  error ? (
    <span id={fieldErrorId(id)} className="sr-only">
      {error}
    </span>
  ) : null;
